// UK SOC 2020 codes commonly used on UKVI Skilled Worker Certificates of
// Sponsorship. Source: GOV.UK "Appendix Skilled Occupations" (Crown © / OGL).
// This is a curated starter list of the most-used occupations — extend as
// needed for your business. Format matches how UKVI SMS displays them:
//   "<4-digit code> <official occupational title>"
export const SOC_CODES = [
  { code: "1132", title: "Marketing, sales and advertising directors" },
  { code: "1136", title: "Information technology directors" },
  { code: "1211", title: "Managers and proprietors in agriculture and horticulture" },
  { code: "1223", title: "Restaurant and catering establishment managers and proprietors" },
  { code: "1224", title: "Publicans and managers of licensed premises" },
  { code: "1225", title: "Leisure and sports managers" },
  { code: "1226", title: "Travel agency managers and proprietors" },
  { code: "1231", title: "Health services and public health managers and directors" },
  { code: "1232", title: "Residential, day and domiciliary care managers and proprietors" },
  { code: "1241", title: "Property, housing and estate managers" },
  { code: "1242", title: "Managers and proprietors in forestry, fishing and related services" },
  { code: "1251", title: "Financial managers and directors" },
  { code: "1252", title: "Managers and directors in retail and wholesale" },
  { code: "1253", title: "Purchasing managers and directors" },
  { code: "1254", title: "Charitable organisation managers and directors" },
  { code: "1255", title: "Human resource managers and directors" },
  { code: "1256", title: "Managers in logistics" },
  { code: "1257", title: "Managers in transport and distribution" },
  { code: "1258", title: "Officers of non-governmental organisations" },
  { code: "1259", title: "Managers and directors in unspecified industries" },
  { code: "2111", title: "Chemical scientists" },
  { code: "2112", title: "Biological scientists" },
  { code: "2113", title: "Physical scientists" },
  { code: "2114", title: "Social and humanities scientists" },
  { code: "2115", title: "Natural and social science professionals n.e.c." },
  { code: "2121", title: "Civil engineers" },
  { code: "2122", title: "Mechanical engineers" },
  { code: "2123", title: "Electrical engineers" },
  { code: "2124", title: "Electronics engineers" },
  { code: "2125", title: "Production and process engineers" },
  { code: "2126", title: "Aerospace engineers" },
  { code: "2127", title: "Engineering project managers and project engineers" },
  { code: "2129", title: "Engineering professionals n.e.c." },
  { code: "2131", title: "IT project managers" },
  { code: "2132", title: "IT managers" },
  { code: "2133", title: "IT business analysts, architects and systems designers" },
  { code: "2134", title: "Programmers and software development professionals" },
  { code: "2135", title: "Cyber security professionals" },
  { code: "2136", title: "IT quality and testing professionals" },
  { code: "2137", title: "IT network professionals" },
  { code: "2139", title: "Information technology professionals n.e.c." },
  { code: "2141", title: "Web design and development professionals" },
  { code: "2142", title: "Graphic and multimedia designers" },
  { code: "2151", title: "Conservation professionals" },
  { code: "2152", title: "Environmental professionals" },
  { code: "2161", title: "Research and development (R&D) managers" },
  { code: "2162", title: "Other researchers, unspecified discipline" },
  { code: "2211", title: "Medical practitioners" },
  { code: "2212", title: "Psychologists" },
  { code: "2213", title: "Pharmacists" },
  { code: "2214", title: "Ophthalmic opticians" },
  { code: "2215", title: "Dental practitioners" },
  { code: "2216", title: "Veterinarians" },
  { code: "2217", title: "Medical radiographers" },
  { code: "2218", title: "Podiatrists" },
  { code: "2219", title: "Health professionals n.e.c." },
  { code: "2221", title: "Physiotherapists" },
  { code: "2222", title: "Occupational therapists" },
  { code: "2223", title: "Speech and language therapists" },
  { code: "2229", title: "Therapy professionals n.e.c." },
  { code: "2231", title: "Nurses" },
  { code: "2232", title: "Midwives" },
  { code: "2311", title: "Higher education teaching professionals" },
  { code: "2312", title: "Further education teaching professionals" },
  { code: "2313", title: "Secondary education teaching professionals" },
  { code: "2314", title: "Primary education teaching professionals" },
  { code: "2315", title: "Nursery education teaching professionals" },
  { code: "2316", title: "Special and additional needs education teaching professionals" },
  { code: "2317", title: "Senior professionals of educational establishments" },
  { code: "2318", title: "Education advisers and school inspectors" },
  { code: "2319", title: "Teaching and other educational professionals n.e.c." },
  { code: "2411", title: "Barristers and judges" },
  { code: "2412", title: "Solicitors" },
  { code: "2419", title: "Legal professionals n.e.c." },
  { code: "2421", title: "Chartered and certified accountants" },
  { code: "2422", title: "Finance and investment analysts and advisers" },
  { code: "2423", title: "Management consultants and business analysts" },
  { code: "2424", title: "Business and financial project management professionals" },
  { code: "2425", title: "Actuaries, economists and statisticians" },
  { code: "2426", title: "Business and related research professionals" },
  { code: "2429", title: "Business, research and administrative professionals n.e.c." },
  { code: "2431", title: "Architects" },
  { code: "2432", title: "Town planning officers" },
  { code: "2433", title: "Quantity surveyors" },
  { code: "2434", title: "Chartered surveyors" },
  { code: "2435", title: "Chartered architectural technologists" },
  { code: "2436", title: "Construction project managers and related professionals" },
  { code: "2441", title: "Public services associate professionals" },
  { code: "2442", title: "Social workers" },
  { code: "2443", title: "Probation officers" },
  { code: "2444", title: "Clergy" },
  { code: "2449", title: "Welfare professionals n.e.c." },
  { code: "2451", title: "Librarians" },
  { code: "2452", title: "Archivists and curators" },
  { code: "2461", title: "Quality control and planning engineers" },
  { code: "2462", title: "Quality assurance and regulatory professionals" },
  { code: "2463", title: "Environmental health professionals" },
  { code: "2464", title: "Occupational health and safety professionals" },
  { code: "2471", title: "Journalists, newspaper and periodical editors" },
  { code: "2472", title: "Public relations professionals" },
  { code: "2473", title: "Advertising accounts managers and creative directors" },
  { code: "3111", title: "Laboratory technicians" },
  { code: "3112", title: "Electrical and electronics technicians" },
  { code: "3113", title: "Engineering technicians" },
  { code: "3114", title: "Building and civil engineering technicians" },
  { code: "3115", title: "Quality assurance technicians" },
  { code: "3116", title: "Planning, process and production technicians" },
  { code: "3119", title: "Science, engineering and production technicians n.e.c." },
  { code: "3121", title: "Architectural and town planning technicians" },
  { code: "3122", title: "Draughtspersons" },
  { code: "3131", title: "IT operations technicians" },
  { code: "3132", title: "IT user support technicians" },
  { code: "3213", title: "Paramedics" },
  { code: "3216", title: "Dispensing opticians" },
  { code: "3217", title: "Pharmaceutical technicians" },
  { code: "3218", title: "Medical and dental technicians" },
  { code: "3219", title: "Health associate professionals n.e.c." },
  { code: "3411", title: "Artists" },
  { code: "3412", title: "Authors, writers and translators" },
  { code: "3413", title: "Actors, entertainers and presenters" },
  { code: "3414", title: "Dancers and choreographers" },
  { code: "3415", title: "Musicians" },
  { code: "3416", title: "Arts officers, producers and directors" },
  { code: "3421", title: "Photographers, audio-visual and broadcasting equipment operators" },
  { code: "3422", title: "Design occupations" },
  { code: "3511", title: "Air traffic controllers" },
  { code: "3512", title: "Aircraft pilots and flight engineers" },
  { code: "3513", title: "Ship and hovercraft officers" },
  { code: "3520", title: "Legal associate professionals" },
  { code: "3531", title: "Estimators, valuers and assessors" },
  { code: "3532", title: "Brokers" },
  { code: "3533", title: "Insurance underwriters" },
  { code: "3534", title: "Finance and investment associate professionals" },
  { code: "3535", title: "Taxation experts" },
  { code: "3536", title: "Importers and exporters" },
  { code: "3537", title: "Financial and accounting technicians" },
  { code: "3538", title: "Financial accounts managers" },
  { code: "3539", title: "Business and related associate professionals n.e.c." },
  { code: "3541", title: "Buyers and procurement officers" },
  { code: "3542", title: "Business sales executives" },
  { code: "3543", title: "Marketing associate professionals" },
  { code: "3544", title: "Estate agents and auctioneers" },
  { code: "3545", title: "Sales accounts and business development managers" },
  { code: "3546", title: "Conference and exhibition managers and organisers" },
  { code: "3549", title: "Sales, marketing and related associate professionals n.e.c." },
  { code: "3550", title: "Conservation and environmental associate professionals" },
  { code: "3551", title: "Public services associate professionals" },
  { code: "3552", title: "Human resources and industrial relations officers" },
  { code: "3553", title: "Vocational and industrial trainers and instructors" },
  { code: "3554", title: "Careers advisers and vocational guidance specialists" },
  { code: "3555", title: "Inspectors of standards and regulations" },
  { code: "3556", title: "Sales accounts and business development managers (associate)" },
  { code: "3557", title: "Advertising and marketing associate professionals" },
  { code: "3558", title: "Business improvement associate professionals" },
  { code: "5111", title: "Farmers" },
  { code: "5112", title: "Horticultural trades" },
  { code: "5113", title: "Gardeners and landscape gardeners" },
  { code: "5114", title: "Groundsmen and greenkeepers" },
  { code: "5119", title: "Agricultural and fishing trades n.e.c." },
  { code: "5211", title: "Smiths and forge workers" },
  { code: "5212", title: "Moulders, core makers and die casters" },
  { code: "5213", title: "Sheet metal workers" },
  { code: "5214", title: "Metal plate workers, and riveters" },
  { code: "5215", title: "Welding trades" },
  { code: "5216", title: "Pipe fitters" },
  { code: "5221", title: "Metal machining setters and setter-operators" },
  { code: "5222", title: "Tool makers, tool fitters and markers-out" },
  { code: "5223", title: "Metal working production and maintenance fitters" },
  { code: "5224", title: "Precision instrument makers and repairers" },
  { code: "5225", title: "Air-conditioning and refrigeration engineers" },
  { code: "5231", title: "Vehicle technicians, mechanics and electricians" },
  { code: "5232", title: "Vehicle body builders and repairers" },
  { code: "5234", title: "Vehicle paint technicians" },
  { code: "5235", title: "Aircraft maintenance and related trades" },
  { code: "5236", title: "Boat and ship builders and repairers" },
  { code: "5237", title: "Rail and rolling stock builders and repairers" },
  { code: "5241", title: "Electricians and electrical fitters" },
  { code: "5242", title: "Telecommunications engineers" },
  { code: "5244", title: "TV, video and audio service and repair technicians" },
  { code: "5245", title: "IT and telecommunications engineers" },
  { code: "5249", title: "Electrical and electronic trades n.e.c." },
  { code: "5250", title: "Skilled metal, electrical and electronic trades supervisors" },
  { code: "5311", title: "Steel erectors" },
  { code: "5312", title: "Bricklayers and masons" },
  { code: "5313", title: "Roofers, roof tilers and slaters" },
  { code: "5314", title: "Plumbers and heating and ventilating engineers" },
  { code: "5315", title: "Carpenters and joiners" },
  { code: "5316", title: "Glaziers, window fabricators and fitters" },
  { code: "5319", title: "Construction and building trades n.e.c." },
  { code: "5321", title: "Plasterers" },
  { code: "5322", title: "Floorers and wall tilers" },
  { code: "5323", title: "Painters and decorators" },
  { code: "5330", title: "Construction and building trades supervisors" },
  { code: "5411", title: "Weavers and knitters" },
  { code: "5412", title: "Upholsterers" },
  { code: "5413", title: "Footwear and leather working trades" },
  { code: "5414", title: "Tailors and dressmakers" },
  { code: "5419", title: "Textiles, garments and related trades n.e.c." },
  { code: "5421", title: "Pre-press technicians" },
  { code: "5422", title: "Printers" },
  { code: "5423", title: "Print finishing and binding workers" },
  { code: "5431", title: "Butchers" },
  { code: "5432", title: "Bakers and flour confectioners" },
  { code: "5433", title: "Fishmongers and poultry dressers" },
  { code: "5434", title: "Chefs" },
  { code: "5435", title: "Cooks" },
  { code: "5436", title: "Catering and bar managers" },
  { code: "5449", title: "Other skilled trades n.e.c." },
  { code: "6121", title: "Nursery nurses and assistants" },
  { code: "6122", title: "Childminders and related occupations" },
  { code: "6123", title: "Playworkers" },
  { code: "6125", title: "Teaching assistants" },
  { code: "6126", title: "Educational support assistants" },
  { code: "6131", title: "Veterinary nurses" },
  { code: "6135", title: "Pest control officers" },
  { code: "6136", title: "Animal care services occupations n.e.c." },
  { code: "6141", title: "Nursing auxiliaries and assistants" },
  { code: "6142", title: "Ambulance staff (excluding paramedics)" },
  { code: "6143", title: "Dental nurses" },
  { code: "6144", title: "Houseparents and residential wardens" },
  { code: "6145", title: "Care workers and home carers" },
  { code: "6146", title: "Senior care workers" },
  { code: "6147", title: "Care escorts" },
  { code: "6148", title: "Undertakers, mortuary and crematorium assistants" },
];

// The format used in the CoS "Job type" field on UKVI SMS is:
//   "<code> <title>"
export function socLabel(entry) {
  return `${entry.code} ${entry.title}`;
}
